<template>
  <div v-loading ="isLoading">
    <button @click="handleCustomersContemplado()" class="btn btn-info btn-fill btn-wd">
      Colocar contemplated=true nos Clientes ganhadores
    </button>
    <el-progress :percentage="progressPercentage"></el-progress>
  </div>
</template>
<script>
  import CouchdbClass from 'src/services/CouchdbClass'
  // import swal from 'sweetalert2'
  import { mapActions } from 'vuex'

  export default {
    data () {
      return {
        isLoading: false,
        progress: 0,
        total: 0
      }
    },
    computed: {
      couchdbCustomers: function () {
        return new CouchdbClass({ connection: 'default', collection: 'customers' })
      },
      couchdbTickets: function () {
        return new CouchdbClass({ connection: 'default', collection: 'tickets' })
      },
      couchdbLamps: function () {
        return new CouchdbClass({ connection: 'default', collection: 'lamps' })
      },
      progressPercentage () {
        if (this.total === 0) {
          return 0
        }
        return parseInt((this.progress / this.total) * 100)
      }
    },
    methods: {
      ...mapActions('customers', {
        fetchCustomers: 'fetchAll',
        upsertCustomer: 'upsert'
      }),

      async handleCustomersContemplado () {
        this.isLoading = true
        const contemplados = []

        let customers = await this.fetchCustomers({
          limit: 99999999
        })

        this.total = customers.length

        for (const customer of customers) {
          await this.checkCustomer(customer)
          customer.cadastroOnline = customer.cadastroOnline || false

          customer.contemplated && contemplados.push(customer)
        }

        await this.couchdbCustomers._updateBulkDocs(contemplados)
        this.isLoading = false
      },

      async checkCustomer (customer) {
        const tickets = await this.couchdbTickets.where('customerId', customer._id).limit(99999999).get()
        const lamps = await this.couchdbLamps.where('customer.id', customer._id).limit(99999999).get()
        const winnerTickets = tickets.filter(ticket => ticket.winner)

        if (lamps.length === 0 && winnerTickets.length === 0) {
          return
        }

        customer.contemplated = true
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/commands/SetCustomerContemplado.vue